import { mergeAttributes, Node } from '@tiptap/core';

const quoteTextFromElement = (element: HTMLElement) => element.textContent?.trim() ?? '';

export const FilingQuoteText = Node.create({
    name: 'filingQuoteText',
    group: 'block',
    atom: true,
    draggable: false,
    isolating: true,
    selectable: false,

    addAttributes() {
        return {
            text: {
                default: '',
                parseHTML: quoteTextFromElement,
            },
        };
    },

    parseHTML() {
        return [
            { tag: 'p[data-filing-quote-text]', priority: 1000 },
            { tag: 'p.filing-source-quote-text', priority: 1000 },
            { tag: 'blockquote.filing-source-quote > p:first-child', priority: 1000 },
        ];
    },

    renderHTML({ HTMLAttributes, node }) {
        return [
            'p',
            mergeAttributes(HTMLAttributes, {
                class: 'filing-source-quote-text',
                contenteditable: 'false',
                'data-filing-quote-text': 'true',
                style: '-webkit-user-select: text; user-select: text;',
            }),
            String(node.attrs.text ?? ''),
        ];
    },
});
